<template>
    <v-layout justify-center>
        <v-container fluid>
            <v-card>
                <v-progress-linear
                  indeterminate
                  v-show="isLoading"
                  color="green"
                ></v-progress-linear>
                <v-tabs v-model="tabs" centered>
                    <v-tab :key="1">Anotações</v-tab>
                    <v-tab :key="2">Tarefas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <v-tab-item>
                        <v-card>
                            <tiptap-vuetify
                              v-model="formData.anotacoes"
                              :card-props="{ flat: true }"
                              :toolbar-attributes="{ color: '#C8E6C9' }"
                              label="Anotações"
                              :extensions="extensions"
                            />
                            <v-card-title class="pb-5">
                                <v-btn
                                    color="success"
                                    :disabled="isLoading"
                                    @click="submitAnotacao"
                                >
                                    Salvar
                                </v-btn>
                            </v-card-title>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-layout column>
                                <v-card-title>
                                    <v-btn text @click="storeTarefas.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Pesquisar"
                                        clearable
                                        single-line
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                    :headers="headers"
                                    :search="search"
                                    :items="storeTarefas.data"
                                    :loading="storeTarefas.isLoading"
                                    :hide-default-footer="true"
                                    disable-pagination
                                    sort-by="nome"
                                    class="elevation-1"
                                >
                                    <template style="d-flex" v-slot:item="{ item }">
                                        <tr>
                                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                                            <td>{{ item.titulo }}</td>
                                            <td>{{ item.horasEstimadas }}</td>
                                            <td>{{ item.horasRealizadas }}</td>
                                            <td>{{ item.stringData }}</td>
                                            <td>{{ item.strConcluida }}</td>
                                            <td class="text-xs-right">
                                                <v-btn icon @click="toTarefaDetalhes(item.id)" text><v-icon medium color="green lighter-4">list_alt</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-layout>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-container>
    </v-layout>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { Store } from '@/utils/Store.js';
import { EventBus } from '@/EventBus';
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify';

export default {
    props: ['id', 'anotacoes'],
    components: { TiptapVuetify },
    created() {
        this.clienteId = this.$route.params.pathMatch;
        this.formData.anotacoes = this.anotacoes;
        this.storeTarefas.baseParams.projeto = this.id;
        this.storeTarefas.load();
    },
    mounted() {
        EventBus.$on('tarefaInserida', (eventParam) => {
            this.storeTarefas.load();
        });
        EventBus.$on('tarefaAlterada', (eventParam) => {
            this.storeTarefas.load();
        });
        EventBus.$on('tarefaRemovida', (eventParam) => {
            this.storeTarefas.load();
        });
    },
    data() {
        return {
            storeTarefas: new Store({
                url: '/tarefas/Tarefas',
                listeners: {
                    load: (storeEl) => {
                        storeEl.allData = storeEl.allData.map((element) => {
                            element.strConcluida = (element.concluida) ? 'Sim' : 'Não';

                            return element;
                        });

                        storeEl.data = JSON.parse(JSON.stringify(storeEl.allData));
                    }
                }
            }),
            isTrue: true,
            isLoading: false,
            formData: {
                anotacoes: ''
            },
            search: '',
            extensions: [
                History,
                Blockquote,
                Link,
                Underline,
                Strike,
                Italic,
                ListItem,
                BulletList,
                OrderedList,
                [Heading, { options: { levels: [1, 2, 3] } }],
                Bold,
                Code,
                HorizontalRule,
                Paragraph,
                HardBreak
            ],
            footerProps: {
                itemsPerPageOptions:  [5, 10, 25, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros por pagina'
            },
            anotacao: '',
            headers: [
                { text: 'Id', align: 'left', sortable: false, value: 'id', width: '60', class: 'hidden-sm-and-down' },
                { text: 'Titulo', align: 'left', value: 'titulo' },
                { text: 'Horas Estimadas', align: 'left', value: 'horasEstimadas' },
                { text: 'Horas Realizadas', align: 'left', value: 'horasRealizadas' },
                { text: 'Data', align: 'left', value: 'stringData' },
                { text: 'Concluida', align: 'left', somenteAbaTodas: true, value: 'strConcluida' },
                { text: '', align: 'center', value: '', width: '60' }
            ],
            tabs: 0
        };
    },
    methods: {
        submitAnotacao() {
            const self = this;
            this.isLoading = true;
            Utils.apiAjax({
                url: '/projetos/ProjetosAnotacoes/' + this.id,
                method: 'put',
                params: {anotacoes: this.formData.anotacoes},
                success: () => {
                    self.isLoading = false;
                    EventBus.$emit('showPopUp', {
                        text: 'Anotacao salva com sucesso'
                    });
                },
                failure: () => {
                    self.isLoading = false;
                    EventBus.$emit('showErrorDialog', 'Erro ao atualizar registro');
                    return true;
                }
            });
        },
        toTarefaDetalhes(id) {
            EventBus.$emit('showTarefaDetalhes', {
                id: id,
                cliente: this.clienteId
            });
        }
    }
}
</script>